module.exports = __webpack_public_path__ + "static/sunkissed-regular-webfont-d8e33a70d78d85355b2f88eff5632fed.woff2";